import { useWeb3React } from '@web3-react/core';
import React, { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import Environment from '../../utils/Environment';
import { taskManagerContract } from '../../utils/contractHelpers';

const TaskDisputedDetails = () => {

    const { account } = useWeb3React();
    const web3 = useWeb3();
    const tokenAddress = Environment.tastManager;
    const contract = taskManagerContract(tokenAddress, web3);

    //This hook for dispute and 2 is parameter
    const taskDisputedDetailsHook = useCallback(
        async (taskId) => {
            console.log(taskId, 'taskId in hook');
            console.log("dispute payload",);

            try {
                // const gas = await contract.methods.taskDisputedDetails(taskId).estimateGas({
                //     from: account
                // });
                const details = await contract.methods.taskDisputedDetails(taskId).call({
                    from: account,
                    // gas,
                });
                return details;
            } catch (error) {
                console.log('errorr', error);

                throw error;
            }
        },
        [contract, account, web3]
    );

    return { taskDisputedDetailsHook: taskDisputedDetailsHook };
}

export default TaskDisputedDetails
